import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { resetPlanSelected } from "@/redux/slices/plan";
import BrandHeader from "@/components/brandHeader";

export default function Confirmation() {
  const dispatch = useAppDispatch();
  const tenant = useAppSelector((state) => state.tenant.loginTenant);

  useEffect(() => {
    dispatch(resetPlanSelected());
  }, [dispatch]);

  return (
    <div className="flex min-h-[100dvh] w-full flex-col px-6 pb-24">
      <header className="mx-auto w-full max-w-7xl py-8">
        <BrandHeader />
      </header>
      <div className="flex flex-1 flex-col items-center justify-center text-center">
      <span
        className="icon-[icon-park--success] text-[var(--tenant-accent-color)]"
        style={{ width: 120, height: 120 }}
      />
      <h1 className="mt-8 font-display text-3xl font-semibold leading-tight md:text-5xl">
        Parabéns, agora você faz parte
        <br />
        do clube {tenant?.Name || "de assinaturas"}
      </h1>
      <p className="mt-4 max-w-md text-checkout-muted">
        Sua assinatura foi confirmada. Aproveite os serviços nas unidades
        participantes.
      </p>
      </div>
    </div>
  );
}
